import React, { useEffect } from 'react';
import './personalisation.css';
// import Aos from "aos";
// import "aos/dist/aos.css";

function Privilages() {

    //     useEffect(() => {
    //     Aos.init({
    //       offset: 0,
    //       duration: 800,
    //       once: true,
    //     });

    //     // Refresh after DOM fully painted
    //     setTimeout(() => {
    //       Aos.refreshHard();
    //     }, 100);

    //   }, []);

    return (
        <section className="investment personalisation">
            <div className="container-lg">

                <div className="row justify-content-center">
                    <div className="col-md-6 col-xxl-5 order-1 order-md-0">
                        <h2 data-aos="fade-up" data-aos-delay="0">Your growth,  <br /> managed personally</h2>
                        <img src="dist/img/personalisation.webp" width={610} height={409} alt="Your growth" className='img-fluid d-block d-md-none personlization-img' />
                        <h3 className='head-gray' data-aos="fade-up" data-aos-delay="200">From investment planning to wealth management, your ICICI Bank Salary Account Relationship Manager works around your schedule, helping you make smarter financial decisions.</h3>
                        <div className="adv_wrap1 mt-5">
                            <div className="pers_wrap" data-aos="fade-up" data-aos-delay="400">
                                <img src="dist/img/icons/portfolio.svg" alt="Portfolio" width={37} height={37} />
                                <p>Portfolio <br /> planning</p>
                            </div>
                            <div className="pers_wrap" data-aos="fade-up" data-aos-delay="600">
                                <img src="dist/img/icons/priority.svg" alt="Priority" width={36} height={36} />
                                <p>Priority <br /> servicing</p>
                            </div>
                        </div>

                    </div>
                    <div className="col-md-6 col-xxl-5">
                        <img src="dist/img/personalisation.webp" width={610} height={409} alt="Your growth" className='img-fluid d-none d-md-block' />
                    </div>
                </div>
            </div>
        </section>

    );
}

export default Privilages;
